/* eslint-disable react/destructuring-assignment, react/no-unused-state */
import React from 'react';
import { Jumbotron } from 'react-bootstrap';
import PropTypes from 'prop-types';

import AjaxHelper from '../common/AjaxHelper';
import TranslationHelper from '../common/TranslationHelper';
import UIHelper from '../common/UIHelper';

import '../css/verify.css';

export default class Verify extends React.Component {
	// eslint-disable-next-line react/static-property-placement
	static contextTypes = {
		// eslint-disable-next-line react/forbid-prop-types
		router: PropTypes.object
	}

	constructor(props, context) {
		super(props, context);

		this.state = {
			// eslint-disable-next-line
			variant: 'success',
			message: TranslationHelper.getValue('customer_account.accountVerified')
		};
	}

	componentDidMount() {
		const token = new URLSearchParams(this.props.location.search).get('token');
		AjaxHelper.invokeServerAPI(`/api/verify/?token=${token}`, {}, (err, docs) => {
			if (err || docs.err) {
				this.setState({
					variant: 'danger',
					message: 'Error'
				});
			} else {
				UIHelper.showInfoMessage(TranslationHelper.getValue('verify.successmessage.verified'));
				setTimeout(() => {
					UIHelper.showSavedPageAfterAuthentication(this);
				}, 2000);
			}
		});
	}

	render() {
		return (
			<div id="verifyAccount" className="loginbackground">
				<Jumbotron className="messageBlock">
					<h1>{this.state.message}</h1>
				</Jumbotron>
			</div>
		);
	}
}
